import { Component, OnInit } from '@angular/core';

import { AnswerTypeComponent } from '../answer-type.component';

@Component({
    selector: 'answer-toggle',
    templateUrl: './answer-toggle.component.html',
    standalone: false
})
export class AnswerToggleComponent extends AnswerTypeComponent implements OnInit {

  ngOnInit() {
    super.ngOnInit();
    if (this.formControlObj && !this.formControlObj.value) {
      setTimeout(() => {
        this.formControlObj?.patchValue(false);
      });
    }
  }

}
